import { Link } from "react-router-dom";
import { AppShell } from "../components/AppShell";
import { useSession } from "../lib/session";

export default function NotFound() {
  const { step } = useSession();
  const body = (
    <div className="wall">
      <p className="wall-code" aria-hidden="true">404</p>
      <h1>There is nothing at this address</h1>
      <p>
        The link may be out of date, or the module may have been renumbered. Each course map lists
        every module, lesson, quiz and lab.
      </p>
      <div className="row">
        <Link className="btn btn-primary" to="/">
          Go to the courses
        </Link>
      </div>
    </div>
  );

  if (step !== "full") {
    return (
      <div className="shell">
        <main id="main" className="main">
          {body}
        </main>
      </div>
    );
  }
  return <AppShell>{body}</AppShell>;
}
